export default __webpack_public_path__ + "static/media/Banner - AirStrapz - Black.0b82c03d.jpg";